import illustration from '../assets/upside-down-tractor.svg'

export const Forbidden403 = ({ message }: { message: string }) => {
  return (
    <div className="text-lg">
      <h2 className="mb-12 text-center text-2xl font-bold text-gray-600">Restricted</h2>
      <img src={illustration} alt="" className="mx-auto -mt-12 w-2/3" />

      <p>{message}</p>
    </div>
  )
}
